import { create, StoreApi, UseBoundStore } from 'zustand'

import { NotificationTypeGroup } from '@/types/notification'

interface NotificationFilterStoreState {
  isUnreadOnly: boolean
  notificationTypeGroup: NotificationTypeGroup[]
}

interface NotificationFilterStoreActions {
  setIsUnreadOnly: (_isUnreadOnly: boolean) => void
  setNotificationTypeGroup: (_notificationTypeGroup: NotificationTypeGroup[]) => void
  reset: () => void
}

type NotificationFilterStore = NotificationFilterStoreState & NotificationFilterStoreActions

const initialState: NotificationFilterStoreState = {
  isUnreadOnly: false,
  notificationTypeGroup: [],
}

const useNotificationFilterStore: UseBoundStore<StoreApi<NotificationFilterStore>> = create((set) => ({
  ...initialState,

  setIsUnreadOnly: (newIsUnreadOnly: boolean) => {
    set((state) => ({
      ...state,
      isUnreadOnly: newIsUnreadOnly,
    }))
  },

  setNotificationTypeGroup: (newNotificationTypeGroup: NotificationTypeGroup[]) => {
    set((state) => ({
      ...state,
      notificationTypeGroup: newNotificationTypeGroup,
    }))
  },

  reset: () => {
    set(initialState)
  },
}))

export { useNotificationFilterStore }
